import { createContext } from 'react';
import createStateProvider from '../../../Shared/createStateProvider';

const StateContext = createContext();

const { StateProvider, useFilterState, useAvailableFilterState } =
  createStateProvider('carriers', StateContext);

export const useLegFilterState = (legId) => {
  const carriersState = useFilterState();
  return (carriersState || {})[legId]?.carriers || null;
};

export default StateProvider;

export { useFilterState, useAvailableFilterState };
